import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5932a33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  action: "/charge",
  method: "post",
  id: "payment-form"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-row" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "card-element" }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "card-errors",
    role: "alert"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  ref: "inviInput",
  type: "tel",
  style: {"border":"0px","color":"transparent","width":"0px","height":"0px","background":"transparent"}
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('checkout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/cart" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.yourOrder')), 1)
                    ]),
                    _: 1
                  }),
                  ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_ion_spinner)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartItems, (item) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: item.productId
                          }, {
                            default: _withCtx(() => [
                              (item.productImage)
                                ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                    key: 0,
                                    slot: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: item.productImage
                                      }, null, 8, _hoisted_3)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, [
                                    _createElementVNode("b", null, _toDisplayString(item.quantity) + " x " + _toDisplayString(item.productName), 1),
                                    _hoisted_4,
                                    _createVNode(_component_ion_note, { color: "dark" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.variantTitle), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("p", null, "HK$" + _toDisplayString(Number(item.unitPrice).toLocaleString()) + " / 1", 1),
                                  _createElementVNode("p", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(Number(item.unitPrice * item.quantity).toLocaleString()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString($setup.t('CartPage.orderTotal')) + "HK$ " + _toDisplayString($setup.getCartTotal().toLocaleString()), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('CheckoutPage.orderRemark')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_textarea, {
                              placeholder: $setup.t('CheckoutPage.specialIntructions'),
                              modelValue: $setup.order.remark,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.order.remark) = $event))
                            }, null, 8, ["placeholder", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }),
              ($setup.needDelivery)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.deliveryInfo')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment, {
                        modelValue: $setup.order.deliveryMethod,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.order.deliveryMethod) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment_button, { value: "送貨上門" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('CheckoutPage.delivery')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_segment_button, { value: "自取" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('CheckoutPage.pickup')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, $setup.pickupPoints.length > 0]
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('deliveryDistrict')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              placeholder: $setup.t('CheckoutPage.selectDistrict'),
                              interface: "popover",
                              modelValue: $setup.order.deliveryDistrict,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.order.deliveryDistrict) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableDistricts, (district) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: district,
                                    value: district
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(district), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["placeholder", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('deliveryAddress')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_textarea, {
                              placeholder: $setup.t('CheckoutPage.enterDeliveryAddress'),
                              modelValue: $setup.order.deliveryAddress,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.order.deliveryAddress) = $event))
                            }, null, 8, ["placeholder", "modelValue"])
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, $setup.order.deliveryMethod == '送貨上門']
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('CheckoutPage.pickupPoint')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              placeholder: $setup.t('CheckoutPage.selectPickupPoint'),
                              interface: "action-sheet",
                              modelValue: $setup.order.pickupPoint,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.order.pickupPoint) = $event)),
                              onIonChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.onPickupPointChanged($event)))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pickupPoints, (point) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: point.id,
                                    value: point.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(point.name ? `[${point.name}] ` : "") + _toDisplayString(point.address), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["placeholder", "modelValue"])
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, $setup.order.deliveryMethod == '自取']
                      ]),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerName')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterCustomerName'),
                            modelValue: $setup.order.customerName,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.order.customerName) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('contactPhone')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterContactPhone'),
                            inputmode: "numeric",
                            modelValue: $setup.order.contactPhone,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.order.contactPhone) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerEmail')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterCustomerEmail'),
                            type: "email",
                            modelValue: $setup.order.customerEmail,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.order.customerEmail) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.contactInfo')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerName')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterCustomerName'),
                            modelValue: $setup.order.customerName,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.order.customerName) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('contactPhone')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterContactPhone'),
                            inputmode: "numeric",
                            modelValue: $setup.order.contactPhone,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.order.contactPhone) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('customerEmail')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            placeholder: $setup.t('CheckoutPage.enterCustomerEmail'),
                            type: "email",
                            modelValue: $setup.order.customerEmail,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.order.customerEmail) = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_radio_group, {
                    modelValue: $setup.order.paymentMethod,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.order.paymentMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentInfo')), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentMethods, (method) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: method.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_radio, {
                              slot: "start",
                              value: method.value
                            }, null, 8, ["value"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(method.key), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_icon, {
                              icon: method.icon,
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("form", _hoisted_5, _hoisted_7, 512), [
                [_vShow, $setup.order.paymentMethod == 'card']
              ]),
              _createElementVNode("input", _hoisted_8, null, 512),
              _withDirectives(_createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        position: "stacked",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentProof')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "file",
                        accept: "image/*",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => ($setup.onPaymentProofChange($event)))
                      }),
                      ($setup.paymentProofDataURL)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.clearUploadedPaymentProof()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  ($setup.paymentProofDataURL)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.paymentProofDataURL,
                        style: {"display":"block","margin":"auto","max-height":"100px"}
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, $setup.order.paymentMethod == 'bank']
              ]),
              _createVNode(_component_ion_button, {
                class: "submit-btn ion-margin-bottom",
                expand: "block",
                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.submitOrder($setup.order)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('CheckoutPage.confirmPayment')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}